<section class="reset-pw">
    <div class="pn-container">
        <div class="reset-container">
            <svg-icon class="reset-container__icon" src="/assets/icons/reset-password.svg" />
            <div class="reset-container__content">
                @switch (resetPwStep) {
                    @case (resetPwStepEnum.TokenInvalid) {
                        <pn-result-notification
                            type="error"
                            pnTitle="Lỗi xác thực"
                            i18n-pnTitle="@@auth.dialog.reset-password.check-token"
                            pnMessage="Đường dẫn xác thực không hợp lệ hoặc đã hết hạn. Vui lòng kiểm tra lại đường dẫn và thử lại. Nếu đường dẫn đã hết hạn, vui lòng gửi lại yêu cầu mới hoặc liên hệ với chúng tôi để biết thêm chi tiết."
                            i18n-pnMessage="@@auth.dialog.reset-password.check-token.description"
                        />
                    }
                    @case (resetPwStepEnum.ResetPWSuccess) {
                        <pn-result-notification
                            type="success"
                            pnTitle="Cập nhật mật khẩu thành công"
                            i18n-pnTitle="@@auth.dialog.reset-password.reset-success"
                            pnMessage="Mật khẩu của bạn đã được cập nhật thành công. Bạn có thể đăng nhập với mật khẩu mới của mình."
                            i18n-pnMessage="@@auth.dialog.reset-password.reset-success.description"
                            actionLabel="Đăng nhập ngay"
                            i18n-actionLabel="@@account-verification.success.sign-in-btn"
                            (actionFn)="handleSignIn($event)"
                        />
                    }
                    @default {
                        <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
                    }
                }
            </div>
        </div>
    </div>
</section>

<ng-template #formTemplate>
    <h3 class="reset-container__content__title" i18n="@@auth.dialog.reset-password">
        Cập nhật mật khẩu
    </h3>

    <form
        [formGroup]="formGroup"
        #ngForm="ngForm"
        [ngClass]="{ 'is-submitted': ngForm.submitted }"
        (ngSubmit)="handleSubmit()"
        class="reset-container__content__form"
    >
        <pn-form-field
            class="order-5"
            containerClass="mt-4"
            formControlName="password"
            label="Mật khẩu"
            i18n-label="@@auth.dialog.labels.password"
            [type]="passwordType"
            prefixIconUrl="assets/icons/lock.svg"
            [errors]="formGroup.get('password')?.errors"
            [validateMessage]="messages['password']"
        >
            <ng-template pnFormFieldSuffix>
                <button
                    type="button"
                    tabIndex="-1"
                    (click)="passwordType = passwordType === 'password' ? 'text' : 'password'"
                >
                    @if (passwordType === 'password') {
                        <svg-icon src="assets/icons/hide-password.svg" svgClass="size-5 " />
                    } @else {
                        <svg-icon
                            src="assets/icons/show.svg"
                            svgClass="size-5 "
                            class="icon:fill-primary-500"
                        />
                    }
                </button>
            </ng-template>
        </pn-form-field>
        <pn-form-field
            class="order-6"
            containerClass="mt-4"
            formControlName="rePassword"
            label="Xác nhận mật khẩu"
            [type]="rePasswordType"
            i18n-label="@@auth.dialog.labels.re-password"
            prefixIconUrl="assets/icons/lock.svg"
            [errors]="[formGroup.get('rePassword')?.errors, formGroup.errors]"
            [validateMessage]="messages['rePassword']"
        >
            <ng-template pnFormFieldSuffix>
                <button
                    type="button"
                    tabIndex="-1"
                    (click)="rePasswordType = rePasswordType === 'password' ? 'text' : 'password'"
                >
                    @if (rePasswordType === 'password') {
                        <svg-icon src="assets/icons/hide-password.svg" svgClass="size-5 " />
                    } @else {
                        <svg-icon
                            src="assets/icons/show.svg"
                            svgClass="size-5 "
                            class="icon:fill-primary-500"
                        />
                    }
                </button>
            </ng-template>
        </pn-form-field>

        <button
            pnButton
            rounded="lg"
            size="large"
            class="group/reset-pw order-7 mt-6 w-full gap-2 flex-center"
            type="submit"
        >
            <span class="font-lato-bold text-lg font-bold" i18n="@@common.buttons.update">
                Cập nhật
            </span>
            @if (loading()) {
                <svg-icon
                    class="ml-2 icon:fill-neutral-01"
                    svgClass="animate-spin size-5"
                    src="/assets/icons/loading.svg"
                />
            } @else {
                <svg-icon
                    src="assets/icons/fi-rr-arrow-small-right.svg"
                    svgClass="size-5"
                    class="w-0 overflow-clip transition-all duration-500 group-hover/reset-pw:w-5 icon:fill-neutral-01"
                    [ngClass]="{ 'w-5': loading() }"
                />
            }
        </button>
    </form>
</ng-template>
